<template>
	<div class="container__subheader">
		<div class="container__subheader__top">
			<div class="container__subheader__top__page__info">
				<label class="container__subheader__top__page__info__title">{{ title }}</label>
				<label class="container__subheader__top__page__info__subtitle">{{ subtitle }}</label>
			</div>
			<div class="container__subheader__actions">
				<slot name="actions" />
			</div>
		</div>
		<div class="container__subheader__main">
			<slot name="main" />
		</div>
	</div>
</template>

<script>
export default {
	props: {
		title: String,
		subtitle: String,
	},
}
</script>

<style scoped>
.container__subheader {
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 100%;
}

.container__subheader__top__page__info {
	display: flex;
	flex-direction: column;
	align-items: center;
}

.container__subheader__top__page__info__title {
	font-size: 1rem;
	font-weight: 700;
	color: rgb(var(--color-primary));
}

.container__subheader__top__page__info__subtitle {
	font-size: 0.75rem;
	color: var(--color-gray);
}

.container__subheader__actions {
	display: flex;
	width: 100%;
	margin-top: 1rem;
	margin: 0;
}

@media screen and (min-width: 992px) {
	.container__subheader {
		padding-top: 1rem;
		flex-direction: column;
	}

	.container__subheader__top {
		display: flex;
		width: 100%;
		justify-content: space-between;
		align-items: center;
	}

	.container__subheader__top__page__info {
		align-items: flex-start;
		width: 30%;
	}

	.container__subheader__actions {
		justify-content: flex-end;
		align-items: center;
		width: 70%;
	}

	.container__subheader__main {
		width: 100%;
	}
}
</style>
